import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MpJoinPage } from './mp-join.page';
import { PagesModule } from '../../pages.module';

const routes: Routes = [
  {
    path: '',
    component: MpJoinPage
  }
];

@NgModule({
  imports: [
    PagesModule,
    RouterModule.forChild(routes)
  ],
  declarations: [MpJoinPage]
})
export class MPJoinPageModule { }
